import { Component, OnDestroy } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { select, Store } from '@ngrx/store'
import * as SettingsActions from 'src/app/store/settings/actions'
import * as Reducers from 'src/app/store/reducers'
import { Subscription } from 'rxjs'

@Component({
	selector: 'app-topbar-language-switcher',
	templateUrl: './language-switcher.component.html',
	styleUrls: ['./language-switcher.component.scss'],
})
export class TopbarLanguageSwitcherComponent implements OnDestroy {
	language: string
	private subscription = new Subscription();

	constructor(private translate: TranslateService, private store: Store<any>) {
		this.subscription.add(this.store.pipe(select(Reducers.getSettings)).subscribe(state => {
			this.language = state.locale.substr(0, 2)
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	changeLanguage(locale: any) {
		this.store.dispatch(
			new SettingsActions.SetStateAction({locale}),
		)
	}
}
